import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';

@Component({
    selector: 'app-overview',
    standalone: true,
    imports: [RouterModule, CardModule],
    template: `
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <p-card header="Locations">
                <p class="m-0">Onboarded locations and their Magento configuration.</p>
                <a routerLink="/locations" class="text-primary font-medium">Open →</a>
            </p-card>
            <p-card header="Magento Instances">
                <p class="m-0">Connected Magento installations.</p>
                <a routerLink="/instances" class="text-primary font-medium">Open →</a>
            </p-card>
            <p-card header="Products">
                <p class="m-0">Product sync requests pushed to Magento.</p>
                <a routerLink="/products" class="text-primary font-medium">Open →</a>
            </p-card>
        </div>
    `
})
export class Overview {}
